module.exports = __webpack_public_path__ + "img/fi-rr-arrow-down.cbf4a822.svg";